// removed by extract-text-webpack-plugin
module.exports = {"moduleSection":"_2n-uyL_d4vmVA6CO4Y3yVd","clientClaimZoomContainer":"WQtv0kZxrzeiSayH-HOmv"};


//////////////////
// WEBPACK FOOTER
// ./components/clients/clientClaims.scss
// module id = 1595
// module chunks = 0